const BadgeTypes = {
  POSITIVE: 'positive',
  NEUTRAL: 'neutral',
  CRITICAL: 'critical',
  PROCESSING: 'processing',
};

const BadgeTypesList = Object.values(BadgeTypes);

export { BadgeTypes, BadgeTypesList };
export default BadgeTypes;
